import { FC } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';

const cx = classnames.bind(styles);

interface Props {
  leftTime?: number;
}

const RecordBadge: FC<Props> = ({ leftTime }) => {
  const formatTime = () => {
    if (!leftTime) return 0;
    const minutes = Math.floor(leftTime / 60);
    const remainingSeconds = leftTime % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className={cx('badge')}>
      <div className={cx('status')}>
        <div className={cx('icon')} />
        <Text fontStyle={FontStyle.B3_M} color={Colors.C_GREEN_150}>
          녹화 중
        </Text>
        <div className={cx('dot')} />
      </div>

      <div className={cx('time')}>
        <div className={cx('icon')} />
        <Text fontStyle={FontStyle.B2P_M} color={Colors.C_WHITE}>
          {formatTime()}
        </Text>
      </div>
    </div>
  );
};

export default RecordBadge;
